import { Validator } from 'modules/application/detail/portal-submodule-builder-pipeline/templates/builder/models/validators/Validator';
import { ValidationError } from 'modules/application/detail/portal-submodule-builder-pipeline/templates/builder/models/validators/ValidatorError';
export class RedirectActionSettingsValidator extends Validator {
    validate(model) {
        if (!model.address) {
            throw new ValidationError('The redirect address is required');
        }
        if (model.context && !model.context.value) {
            throw new ValidationError('The context value is required');
        }
    }
}
